/* eslint-disable default-case */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { SelectedPlansTypes, SelectedPlansState } from './types';

const INITIAL_STATE: SelectedPlansState = {
  selectedPlan: {
    nome_plano: '',
    statusAssinaturaDigital: false,
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<SelectedPlansState> = (
  state = INITIAL_STATE,
  { type, layout, statusAssinaturaDigital },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case SelectedPlansTypes.GET_SELECTED_PLAN_REQUEST:
        draft.selectedPlan.nome_plano = layout;
        draft.selectedPlan.statusAssinaturaDigital = statusAssinaturaDigital;
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      default:
    }
  });
};
export default reducer;
